module.exports = __webpack_public_path__ + "cb3192379a293fdfaa954426b31b5bce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/close_btn.png
// module id = 408
// module chunks = 0